<template>
  <div class="container">
    <div class="my-3" v-loading="loading">
      <b-card class="script-details">
        <template slot="header">
          <div class="text-left">
            <h5 class="id mb-0">{{login.name}}</h5>
          </div>
        </template>
        <div class="full-detail">
          <div class="row">
            <div class="col-md-6">
              <div class="prf-dtl">
                <label class="d-block mb-1">{{lang.label.emailId}}:</label>
                <span class="d-block">{{(login.email!='' ? login.email : lang.label.nodata)}}</span>
              </div>
              <div class="prf-dtl">
                <label class="d-block mb-1">{{lang.label.mobileNumber}}:</label>
                <span class="d-block">{{(login.mobile!='' ? login.mobile : lang.label.nodata)}}</span>
              </div>
              <div class="prf-dtl">
                <label class="d-block mb-1">{{lang.label.gender}}:</label>
                <span class="d-block">{{(login.gender!='' ? login.gender : lang.label.nodata)}}</span>
              </div>
              <div class="prf-dtl">
                <label class="d-block mb-1">{{lang.label.address}}:</label>
                <span class="d-block">{{(login.location!='' && login.location!=null ? login.location : lang.label.nodata)}}</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="prf-dtl">
                  <template v-if="signature">
                <label class="d-block mb-1">{{lang.label.signature}}:</label>
                <span class="d-block">
                  <img :src="signature" height="92" width="133" alt />
                </span>
                  </template>
              </div>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import jsondata from "../assets/json/data.json";
import {mapGetters} from "vuex";

export default {
  components: {},
  data() {
    return {
      data: jsondata,
      signature:'',
      lang: this.$lang.profile_detail,
    };
  },
  computed: {
    ...mapGetters({
      login: "login",
      loading: "loading",
    })
  },
  mounted(){
    let self = this;
    this.$store.dispatch('getSignature').then(response => {
      if(response.data){
        self.signature = response.data.signature;
        self.signature = response.data.signature;
      }
    });
  },
  methods: {
    getImgUrl(pic) {
      return require("../assets/styles/img/" + pic);
    }
  }
};
</script>
